<section class="about-us-container">
  <section class="about-us-hero-section">
    <span class="x-large-font font-white">About Us</span>
    <div id="about-hero-copy">
      <p class="body-font font-white">
        MedShorts was founded in 2015 as a free-market eCommerce solution for
        short-dated drugs. In a climate where drug prices continue to climb and
        access to medication often gets interrupted, we believe in value
        creation, waste reduction, and industry sustainability.
      </p>
      <p class="body-font font-white">
        The alternative channel solution we created comprises of a community of
        pharmacies and drug manufacturers motivated to take action.
      </p>
      <p class="body-font font-white">
        Our team of software developers, pharmacy clinicians, data scientists,
        and healthcare industry professionals are dedicated to asking thoughtful
        questions, listening intently, and building our marketplace accordingly.
        Using technology and innovation, we strive to improve transparency and
        sustainability in the pharmaceutical supply chain.
      </p>
      <p class="body-font font-white">
        MedShorts is located in the heart of sunny, downtown Orlando.
      </p>
    </div>
  </section>
  <section class="about-us-image-section">
    <img
      id="ms-image-1"
      src="/assets/img/static-pages/medshorts/medshorts-confrence-room.jpg"
      alt="Medshorts Conference Room"
    />
    <img
      id="ms-image-2"
      src="/assets/img/static-pages/medshorts/medshorts-front-office.jpg"
      alt="Medshorts Front Office"
    />
  </section>
  <section class="say-hello-section">
    <span class="x-large-font font-white">Say Hello!</span>
    <p class="body-font bold-font font-white">
      Our staff is here to listen, serve, and support
    </p>
    <p class="underline body-font font-white">
      <a class="text-white" href="mailto: info@medshorts.com"
        >info"&#64;medshorts.com</a
      >
    </p>
    <p class="underline body-font font-white">844-733-5633</p>
    <p class="body-font font-white">
      200 East Robinson Street | Suite 1250 | Orlando, Florida 32801
    </p>
    <section class="social-media">
      <ul>
        <li>
          <a href="https://www.facebook.com/medshorts" target="_blank"
            ><img
              src="/assets/img/static-pages/medshorts/Facebook-icon.png"
              alt="Facebook logo"
          /></a>
        </li>
        <li>
          <a href="https://twitter.com/MedshortsLLC" target="_blank"
            ><img
              src="/assets/img/static-pages/medshorts/Twitter-icon.png"
              alt="Twitter logo"
          /></a>
        </li>
        <li>
          <a href="https://www.instagram.com/medshorts/" target="_blank"
            ><img
              src="/assets/img/static-pages/medshorts/Instagram-icon.png"
              alt="Instagram logo"
          /></a>
        </li>
        <li>
          <a href="https://www.linkedin.com/company/medshorts/" target="_blank"
            ><img
              src="/assets/img/static-pages/medshorts/LinkedIn-icon.png"
              alt="LinkedIn logo"
          /></a>
        </li>
      </ul>
    </section>
  </section>
  <section class="about-us-map-section">
    <div class="mapouter">
      <div class="gmap_canvas">
        <iframe
          width="100%"
          height="500"
          id="gmap_canvas"
          src="https://maps.google.com/maps?q=200%20East%20Robinson%20Street%20%7C%20Suite%201250%20%7C%20Orlando,%20Florida%2032801&t=&z=15&ie=UTF8&iwloc=&output=embed"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
        ></iframe
        ><a href="https://fmovies-online.net">fmovies</a><br />
        <style>
          .mapouter {
            position: relative;
            text-align: right;
            height: 500px;
            width: 100%;
          }</style
        ><a href="https://www.embedgooglemap.net">google map plugin html</a>
        <style>
          .gmap_canvas {
            overflow: hidden;
            background: none !important;
            height: 500px;
            width: 100%;
          }
        </style>
      </div>
    </div>
  </section>
  <section class="contact-us-form-section">
    <i *ngIf="!hasMessage && !isUrlTestimonial" style="color: #777777"
      >For general inquiries please fill in the following form:</i
    >
    <i *ngIf="!hasMessage && isUrlTestimonial" style="color: #777777"
      >Submit your testimonial:</i
    >
    <app-static-footer></app-static-footer>
    <div *ngIf="hasMessage && !isUrlTestimonial" class="alert">
      Thanks for the inquiry.
    </div>
    <div *ngIf="hasMessage && isUrlTestimonial" class="alert">
      Thank you for submitting your testimonial.
    </div>
  </section>
</section>
